import { InteractionType, InteractionStatus, InteractionRequiredAuthError } from "@azure/msal-browser";
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal, useMsalAuthentication } from "@azure/msal-react";
import { useQuery } from "@tanstack/react-query";
import { Flex } from "antd";
import { useEffect } from "react";
// import { Outlet } from "react-router-dom";
import { toast } from "react-toastify";

import styles from "./DataversePage.module.scss";

import { getImportConfigurations } from "../../api/template/template";
// import { DataverseInstances } from "../../components/Dataverse/Instances";
import { DestinationSelector } from "../../components/Dataverse/DestinationSelector";
import { CustomButton } from "../../components/FormFields/CustomButton";
import { MSALBar } from "../../components/MSAL/MSALBar";
import { useUserData } from "../../hooks/useUserProfile";
import { setSliceDataverseImportConfigurations } from "../../store/slices/importConfigurationSlice";
import { createErrorMessage } from "../../utils/createErrorMessage";


export const DataversePage = () => {
    const { organizationId, tenantId } = useUserData();
    const request = { scopes: ["https://globaldisco.crm.dynamics.com/.default"], prompt: "consent"};
    const { error, login } = useMsalAuthentication(InteractionType.Silent, request);

    useQuery({
        queryKey: ["getImportConfigurations", tenantId, organizationId, "DataverseAdapter"],
        queryFn: async () => {
            try {
                const res = await getImportConfigurations(
                    organizationId,
                    tenantId,
                    "DataverseAdapter"
                );

                setSliceDataverseImportConfigurations(res.data.data);

                return res.data.data;
            } catch (error) {
                toast.error(createErrorMessage(error));
            }
        },
        enabled: !!tenantId && !!organizationId
    });
    
    useEffect(() => {
       if (error instanceof InteractionRequiredAuthError) {
            login(InteractionType.Popup, request);
        }
    }, []);

    const { instance, accounts, inProgress} = useMsal();

    useEffect(() => {
        instance.setActiveAccount(accounts[0] || null);
    }, [accounts]);

    if (inProgress === InteractionStatus.Startup) {
        return <div>Initializing...</div>;
    }  
    
    return (
        <Flex
            vertical
            align="flex-start"
            gap={20}
            justify="flex-start"
            className={styles.root}
        >
            <AuthenticatedTemplate>
                <MSALBar />
                <DestinationSelector />
                {/* <DataverseInstances /> */}
                {/* <Outlet /> */}
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                <Flex
                    vertical
                    align="center"
                    gap={20}
                    justify="flex-start"
                    className={styles.root}
                >
                    <CustomButton
                        onClick={() => login(InteractionType.Popup, request)}
                        isLoading={inProgress === InteractionStatus.Login}
                    >
                        {inProgress === InteractionStatus.Login ? "Check for login popup" : "Login with Microsoft"}
                    </CustomButton>
                </Flex>
            </UnauthenticatedTemplate>
        </Flex>
    );
}